<emoji-mart
  (emojiClick)="addEmoji($event)"
  title="Emojis"
  sheetSize="32"
  showSingleCategory="true"
  [style]="{ width: '100%', overflow: 'hidden' }"
></emoji-mart>
